import { fullNameSchema } from "@/shared/schema/full-name";
import { usernameSchema } from "@/shared/schema/username";
import dayjs from "dayjs";
import z from "zod";

export const MIN_PROFILE_AGE = 16;

export const ProfileSchema = z.object({
  full_name: fullNameSchema,
  username: usernameSchema,
  birth_date: z
    .string()
    .min(1, { message: "validation_errors.required_birth_date" })
    .superRefine((value, ctx) => {
      const parsedDate = dayjs(value);

      if (!parsedDate.isValid()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation_errors.required_birth_date",
        });
        return;
      }

      const age = dayjs().diff(parsedDate, "year");

      if (age < MIN_PROFILE_AGE) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation_errors.age_too_young",
        });
      }
    }),
  gender: z.enum(["MALE", "FEMALE"]).optional(),
  avatar_id: z.string().nullish(),
  region_id: z.string(),
  district_id: z.string()
});

export type ProfilePayload = z.infer<typeof ProfileSchema>;
